const WHATSAPP_NUMBER = "5561982574468";
const WHATSAPP_MESSAGE = encodeURIComponent(
  "Olá, vim pelo site e gostaria de mais informações",
);
const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}?text=${WHATSAPP_MESSAGE}`;

const colors = {
  navy: "#0A1628",
  navyLight: "#0F2040",
  blue: "#1565C0",
  blueLight: "#1E88E5",
  blueBright: "#42A5F5",
  accent: "#00B4D8",
  accentLight: "#48CAE4",
  white: "#FFFFFF",
  offWhite: "#F0F4FA",
  lightGray: "#E8EEF8",
  midGray: "#8FA3C8",
  dark: "#06101E",
  cardBg: "#0D1E35",
  glass: "rgba(255,255,255,0.05)",
  glassHover: "rgba(255,255,255,0.1)",
};

const IconWhatsApp = ({ size = 24 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
  </svg>
);

// ── Stats
const stats = [
  { value: "2k+", label: "Equipamentos Reparados" },
  { value: "98%", label: "Satisfação dos Clientes" },
  { value: "8+", label: "Anos de Experiência" },
  { value: "3D", label: "Prazo Médio de Entrega" },
];

const Hero = () => {
  return (
    <section
      id="inicio"
      className="hero-grid"
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        padding: "120px 24px 80px",
        position: "relative",
        overflow: "hidden",
        background: `linear-gradient(160deg, ${colors.dark} 0%, ${colors.navyLight} 50%, ${colors.dark} 100%)`,
      }}
    >
      {/* Decorative blobs */}
      <div
        style={{
          position: "absolute",
          top: "15%",
          right: "5%",
          width: 500,
          height: 500,
          borderRadius: "50%",
          background: `radial-gradient(circle, rgba(21,101,192,0.15) 0%, transparent 70%)`,
          filter: "blur(40px)",
          animation: "float 6s ease-in-out infinite",
          pointerEvents: "none",
        }}
      />
      <div
        style={{
          position: "absolute",
          bottom: "10%",
          left: "-5%",
          width: 400,
          height: 400,
          borderRadius: "50%",
          background: `radial-gradient(circle, rgba(0,180,216,0.1) 0%, transparent 70%)`,
          filter: "blur(60px)",
          pointerEvents: "none",
        }}
      />

      <div
        style={{
          maxWidth: 1200,
          margin: "0 auto",
          width: "100%",
          position: "relative",
          zIndex: 1,
        }}
      >
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: 60,
            alignItems: "center",
          }}
          className="hero-grid-inner"
        >
          {/* Left content */}
          <div style={{ animation: "fadeInUp 0.8s ease forwards" }}>
            <div
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 8,
                background: "rgba(0,180,216,0.1)",
                border: `1px solid rgba(0,180,216,0.3)`,
                borderRadius: 100,
                padding: "6px 16px",
                marginBottom: 24,
              }}
            >
              <div
                style={{
                  width: 6,
                  height: 6,
                  borderRadius: "50%",
                  background: colors.accent,
                  boxShadow: `0 0 8px ${colors.accent}`,
                }}
              />
              <span
                style={{
                  color: colors.accentLight,
                  fontSize: 13,
                  fontWeight: 500,
                  textTransform: "uppercase",
                }}
              >
                Assistência Técnica Especializada em Brasília!
              </span>
            </div>

            <h1
              style={{
                fontFamily: "'Syne', sans-serif",
                fontSize: "clamp(2.2rem, 5vw, 3.6rem)",
                fontWeight: 800,
                lineHeight: 1.1,
                marginBottom: 20,
                color: colors.white,
              }}
            >
              Soluções{" "}
              <span className="gradient-text">rápidas e confiáveis</span> para
              seus equipamentos
            </h1>

            <p
              style={{
                fontSize: 18,
                color: colors.midGray,
                lineHeight: 1.7,
                marginBottom: 36,
                maxWidth: 480,
              }}
            >
              Especialistas em lavadoras de alta pressão, enceradeiras,
              aspiradores e compressores em Brasília. Conserto rápido com
              garantia de serviço.
            </p>

            <div style={{ display: "flex", gap: 14, flexWrap: "wrap" }}>
              <a
                href={WHATSAPP_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="btn-primary"
                style={{
                  background: `linear-gradient(135deg, #25d366, #128c7e)`,
                  color: colors.white,
                  textDecoration: "none",
                  padding: "15px 28px",
                  borderRadius: 12,
                  fontSize: 16,
                  fontWeight: 600,
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 10,
                }}
              >
                <IconWhatsApp size={20} />
                Fale conosco no WhatsApp
              </a>
              <a
                href="#servicos"
                className="btn-outline"
                style={{
                  border: `1px solid rgba(255,255,255,0.2)`,
                  color: colors.white,
                  textDecoration: "none",
                  padding: "15px 28px",
                  borderRadius: 12,
                  fontSize: 16,
                  fontWeight: 500,
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 10,
                }}
              >
                Ver Serviços
              </a>
            </div>
          </div>

          {/* Right: Stats panel */}
          <div
            style={{
              animation: "fadeInUp 0.8s ease 0.2s both",
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: 16,
            }}
          >
            {stats.map(({ value, label }) => (
              <div
                key={label}
                style={{
                  background: colors.glass,
                  border: `1px solid rgba(255,255,255,0.08)`,
                  borderRadius: 16,
                  padding: "28px 24px",
                  backdropFilter: "blur(10px)",
                  textAlign: "center",
                }}
              >
                <div
                  style={{
                    fontFamily: "'Syne', sans-serif",
                    fontSize: 36,
                    fontWeight: 800,
                    lineHeight: 1,
                    marginBottom: 8,
                  }}
                  className="gradient-text"
                >
                  {value}
                </div>
                <div
                  style={{
                    color: colors.midGray,
                    fontSize: 13,
                    fontWeight: 400,
                    lineHeight: 1.4,
                  }}
                >
                  {label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Bottom fade */}
      <div
        style={{
          position: "absolute",
          bottom: 0,
          left: 0,
          right: 0,
          height: 120,
          background: `linear-gradient(to bottom, transparent, ${colors.dark})`,
          pointerEvents: "none",
        }}
      />

      <style>{`
        @media (max-width: 768px) {
          .hero-grid-inner { grid-template-columns: 1fr !important; gap: 40px !important; }
        }
      `}</style>
    </section>
  );
};

export default Hero;
